import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addVisaToProposal, removingVisa } from "../../actions/proposal";
import { closeModal } from "../../actions/ui";
import { images } from "../../constants";
import LoaderDots from "../generalComponents/LoaderDots";
import "./ProposalVisaSelect.scss";

const ProposalVisaSelect = () => {
  const visas = useSelector((state) => state.visa.visa);
  const visaSelected = useSelector((state) => state.proposals.visa);
  const visasFlat = visaSelected.map((visa) => visa._id);

  const dispatch = useDispatch();

  const handleAddVisa = (visa) => {
    const visaAdded = { ...visa, quantity: 1 };

    dispatch(addVisaToProposal(visaAdded));
    dispatch(removingVisa());
    dispatch(closeModal());

  };

  if (visas.length === 0) {
    <LoaderDots />;
  }
  return (
    <div className="visa-select">
      <ul className="visa-select__list-container">
        {visas?.map((visa) => (
          <div key={visa._id} className="visa-select__item">
            <div className="visa-select__item--heading">
              <div className="item--heading__img">
                <img src={images.logoVisa} alt="" />
              </div>

              <div className="item__heading--name">
                <h2 className="title-gray-bold-16">{visa.name}</h2>
                <h2 className="paragraph-gray-reg-16">{visa.subname}</h2>
              </div>

              <div className="item__heading--prices">
                <div>
                  <span className="paragraph-gray-reg-14">Visa Fee:</span>
                  <span className="paragraph-gray-bold-14">
                    {" "}
                    ${visa.visafee}
                  </span>
                </div>

                <div>
                  <span className="paragraph-gray-reg-14">Extra Fee:</span>
                  <span className="paragraph-gray-bold-14">
                    ${visa.extrafee}
                  </span>
                </div>
                <div>
                  <span className="paragraph-gray-reg-14">Total:</span>
                  <span className="paragraph-gray-bold-14"> ${visa.total}</span>
                </div>
              </div>
            </div>

            <div className="visa-select__item--icons">
              {visasFlat.includes(visa._id) ? (
                <button className="btn-disable">added</button>
              ) : (
                <button
                  className="btn-primary"
                  onClick={() => handleAddVisa(visa)}
                >
                  + add
                </button>
              )}
            </div>
          </div>
        ))}
      </ul>
    </div>
  );
};

export default ProposalVisaSelect;
